import React from 'react';
import {LegalInformation} from 'app/components/LegalInformation';
import {usePolicyQuery} from 'app/components/entities/user';

export function UsePolicy() {
  const {data} = usePolicyQuery();
  return <LegalInformation title="Epiphan Acceptable Use Policy" content={data?.Policy ?? ''} />;
}
